import { ReactNode } from 'react';

/**
 * MobileListHeader - Header section for mobile lists
 * Shows title and actions (like "Select" button)
 */
export function MobileListHeader({
  title,
  icon,
  headerActions,
  enableSelection: _enableSelection,
  selectedIds = [],
  onClearSelection,
}: {
  title?: string;
  icon?: ReactNode;
  headerActions?: ReactNode;
  enableSelection?: boolean;
  selectedIds?: string[];
  onClearSelection?: () => void;
}) {
  const hasSelections = selectedIds.length > 0;

  return (
    <div
      className='sticky top-0 z-10 touch-none overscroll-contain border-b
        border-gray-200 bg-white px-4 py-4'
    >
      <div className='flex items-center justify-between'>
        {/* Icon and Title */}
        <div className='flex items-center gap-2'>
          {icon && (
            <div className='text-focus flex h-4 w-4 items-center justify-center'>
              {icon}
            </div>
          )}
          <h2 className='size-p1 text-focus font-bold'>{title}</h2>
        </div>

        {/* Actions */}
        <div className='flex items-center gap-2'>
          {hasSelections && onClearSelection && (
            <button
              onClick={onClearSelection}
              className='text-sm font-medium text-blue-600 hover:text-blue-800'
            >
              Clear
            </button>
          )}
          {headerActions}
        </div>
      </div>
    </div>
  );
}
